export const migrationData = [
  {
    "year": "2013",
    "HNWIsMigrated": 51000,
    "notes": ""
  },
  {
    "year": "2014",
    "HNWIsMigrated": 57000,
    "notes": ""
  },
  {
    "year": "2015",
    "HNWIsMigrated": 64000,
    "notes": ""
  },
  {
    "year": "2016",
    "HNWIsMigrated": 82000,
    "notes": ""
  },
  {
    "year": "2017",
    "HNWIsMigrated": 95000,
    "notes": ""
  },
  {
    "year": "2018",
    "HNWIsMigrated": 108000,
    "notes": ""
  },
  {
    "year": "2019",
    "HNWIsMigrated": 110000,
    "notes": ""
  },
  {
    "year": "2020",
    "HNWIsMigrated": 12000,
    "notes": "Coronavirus impact"
  },
  {
    "year": "2021",
    "HNWIsMigrated": 25000,
    "notes": "Coronavirus impact"
  },
  {
    "year": "2022",
    "HNWIsMigrated": 84000,
    "notes": ""
  },
  {
    "year": "2023",
    "HNWIsMigrated": 122000,
    "notes": "Forecast"
  },
  {
    "year": "2024",
    "HNWIsMigrated": 128000,
    "notes": "Forecast"
  }
]